import axios from 'axios';
import { showTabs, selectTab } from '../../common/tab/tabActions';
import consts from '../../consts';
import { setErroAPI, setSuccess } from '../../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../../common/dateFormat/DateFormat';
import FormatUtils from '../../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PROSPECCAO_EVENTO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('prospeccaoEventoForm', registro)
    ];
}

export function getLista(id_prospeccao) {
    const request = axios.get(`${consts.API_URL}/prospeccaoEvento?id_prospeccao=${id_prospeccao}`);
    return {
        type: 'PROSPECCAO_EVENTO_LISTADO',
        payload: request
    };
}

export function getListaPedido(id_prospeccao) {
    const request = axios.get(`${consts.API_URL}/pedido/listarEventoProspeccao?id_prospeccao=${id_prospeccao}`);
    return {
        type: 'PROSPECCAO_EVENTO_PEDIDO_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/prospeccaoEvento`, {
				...registro,
				formulario_venda_perdida: {
					...(registro.formulario_venda_perdida || {}),
					quantidade: registro.formulario_venda_perdida ? FormatUtils.formatarValorBanco(registro.formulario_venda_perdida.quantidade, 0) : null,
					proposta: registro.formulario_venda_perdida ? FormatUtils.formatarValorBanco(registro.formulario_venda_perdida.proposta, 4) : null,
					prazo: registro.formulario_venda_perdida ? FormatUtils.formatarValorBanco(registro.formulario_venda_perdida.prazo, 0) : null,
					valor_fechado: registro.formulario_venda_perdida ? FormatUtils.formatarValorBanco(registro.formulario_venda_perdida.valor_fechado, 4) : null
				},
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_prospeccao));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/prospeccaoEvento`, {
				...registro,
				formulario_venda_perdida: {
					...(registro.formulario_venda_perdida || {}),
					quantidade: registro.formulario_venda_perdida ? FormatUtils.formatarValorBanco(registro.formulario_venda_perdida.quantidade, 0) : null,
					proposta: registro.formulario_venda_perdida ? FormatUtils.formatarValorBanco(registro.formulario_venda_perdida.proposta, 4) : null,
					prazo: registro.formulario_venda_perdida ? FormatUtils.formatarValorBanco(registro.formulario_venda_perdida.prazo, 0) : null,
					valor_fechado: registro.formulario_venda_perdida ? FormatUtils.formatarValorBanco(registro.formulario_venda_perdida.valor_fechado, 4) : null
				},
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_prospeccao));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/prospeccaoEvento?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(registro.id_prospeccao));
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}
